import { StyleSheet, Dimensions, Platform } from 'react-native'

import { Colors, Metrics } from '../Themes';

const screenWidth = Dimensions.get('window').width;


const elevationStyle = {
  elevation: 1,
  shadowColor: 'rgb(0, 0, 0)',
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowRadius: 8,
  shadowOpacity: 0.16,
};

const heightToWidthRatio = 0.479;
const addMoreHeightToWidthRatio = Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0.338 : 0.45

const mainCardWidth = Platform.OS === 'web' && Dimensions.get('window').width > 700 ? (screenWidth - Metrics.mainContentPadding * 2) / 2 : screenWidth - Metrics.mainContentPadding * 2



const main = theme => ({
  width: mainCardWidth,
  height: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : mainCardWidth * heightToWidthRatio,
  minHeight: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 'auto' : null,
  borderRadius: 6,
  backgroundColor: theme.colors.cardBackgroundColor,
});
const sec = theme => ({
  width: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 'auto' : mainCardWidth * heightToWidthRatio,
  height: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 'auto' : mainCardWidth * heightToWidthRatio,
  minHeight: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 250 : mainCardWidth * heightToWidthRatio,
  borderRadius: 6,
  backgroundColor: theme.colors.cardBackgroundColor,
});
const addMore = theme => ({
  width: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : mainCardWidth * heightToWidthRatio,
  flex: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 1 : null,
  height: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? mainCardWidth * 0.45 * addMoreHeightToWidthRatio : mainCardWidth * heightToWidthRatio * 0.45,
  borderRadius: 6,
  backgroundColor: theme.colors.cardBackgroundColor,
});
export default StyleSheet.create({
  main: (theme, hasShadow = true) =>
    hasShadow
      ? {
        ...main(theme),
        ...elevationStyle,
      }
      : main(theme),
  sec: (theme, hasShadow = true) =>
    hasShadow
      ? {
        ...sec(theme),
        ...elevationStyle,
      }
      : sec(theme),
  addMore: (theme, hasShadow = true) =>
    hasShadow
      ? {
        ...addMore(theme),
        ...elevationStyle,
      }
      : addMore(theme),
  withAddButton: {
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderStyle: 'dashed',
  },
  gallery: {
    width: Metrics.galleryCardWidth,
    height: 182,
    marginRight: Metrics.galleryCardMargin,
    backgroundColor: Colors.transparent,
  },
  discover: {
    width: screenWidth - Metrics.mainContentPadding * 2,
    maxHeight: 300,
    marginVertical: 10,
    borderRadius: 10,
    backgroundColor: Colors.cardBackground,
    overflow: 'hidden',
    ...elevationStyle,
  },
  discover_fixed_component: {
    width: mainCardWidth,
    height: mainCardWidth * 0.55,
    borderRadius: 10,
    backgroundColor: Colors.cardBackground,
    overflow: 'hidden',
  },
  icon: {
    width: 30,
    height: 30,
  },
  shimmerContainer: {
    padding: 10,
    overflow: 'hidden',
  },
});
